export const BackArrow = () => (
    <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.6087 1L2 7L8.6087 12.5" stroke="#CBCBCB" strokeWidth="2"/>
</svg>

)